import * as React from 'react';

import { ElamaIcon } from 'shared/newComponents/icons';
import { Popup } from 'shared/components/popups';
import { IconSize } from 'shared/entities/components/Icon';
import TypedTransComponent from 'shared/components/TypedTransComponent';
import ExternalLink from 'shared/components/ExternalLink';
import { ELAMA_SUPPORT_MAIL_LINK } from 'shared/entities/app';
import { PopupEventType } from 'shared/entities/components/Popup';

type Props = {
  className?: string;
};

const ELamaPopup: React.FC<Props> = ({ className }) => {
  return (
    <Popup
      on={PopupEventType.hover}
      trigger={
        <div className={className}>
          <ElamaIcon className="hoverable" iconSize={IconSize.XXLL} />
        </div>
      }
    >
      <TypedTransComponent ns="components" i18nKey="ELamaPopup">
        Если у вас есть вопрос, напишите нам на{' '}
        <ExternalLink
          className="link"
          href={`mailto:${ELAMA_SUPPORT_MAIL_LINK}`}
        >
          {{ link: ELAMA_SUPPORT_MAIL_LINK }}
        </ExternalLink>{' '}
        или в чат через личный кабинет eLama
      </TypedTransComponent>
    </Popup>
  );
};

export default ELamaPopup;
